<template>
  <div class="home-container">
    <div class="main-content">
      <!-- 顶部问候区域 -->
      <el-row class="greeting-section" :gutter="0">
        <el-col class="emoji" :span="4">
          <img :src="emojiUrl" alt="emoji" />
        </el-col>
        <el-col :span="22">
          <h1 class="greeting-text">
            {{ greetingText }}老师，有什么可以帮您？
          </h1>
        </el-col>
      </el-row>

      <!-- 输入区域 -->
      <div class="input-section">
        <div class="input-container">
          <textarea
            v-model="inputText"
            class="input-textarea"
            :placeholder="defaultPlaceholder"
            rows="4"
            @click="handleInputClick"
            @keydown.enter="handleKeyDown"
          ></textarea>
          <div class="action-buttons">
            <div
              v-if="isShowDeepThink"
              class="deep-think-btn"
              @click="handleDeepThink"
              :class="{ 'is-deep-think': isDeepThink }"
            >
              <img
                :src="isDeepThink ? deepThinkIconActive : deepThinkIcon"
                alt="deep-think"
                class="deep-think-icon"
              />
              <span>深度思考</span>
            </div>
            <img
              class="send-btn"
              @click="handleSend"
              src="@/assets/images/laoshibang/send-icon.png"
              alt="send"
            />
          </div>
        </div>
      </div>
      <AppSearchButtons
        class="app-search-buttons"
        :functionItems="functionItems"
        @handleClick="handleFunctionClick"
      />
    </div>
  </div>
</template>

<script>
import {
  getRecommendAppList,
  addAiassistantList,
  getAiassistantInfo,
  addMyAppList,
} from "@/api/home";
import sObserver from "@/utils/simpleObserver";
import { getLocalToken } from "@/utils/token";
import AppSearchButtons from "@/components/AppSearchButtons.vue";
import sensors from "sa-sdk-javascript";

export default {
  name: "NewHome",
  components: {
    AppSearchButtons,
  },
  data() {
    return {
      emojiUrl: require("@/assets/images/laoshibang/emoji-2X.png"),
      moreAppIcon: require("@/assets/images/laoshibang/more.png"),
      deepThinkIcon: require("@/assets/images/chat/deep.png"),
      deepThinkIconActive: require("@/assets/images/chat/deeps.png"),
      inputText: "",
      // 预设的功能按钮数据，实际使用时从接口获取
      functionItems: [],
      checkedLoginInfo: false,
      category: "",
      isDeepThink: false,
      isShowDeepThink: 0,
      currentAppId: "",
      prologueDesc: "",
    };
  },
  computed: {
    // 根据当前时间返回问候语
    greetingText() {
      const now = new Date();
      const hour = now.getHours();

      if (hour >= 5 && hour < 11) {
        return "早上好";
      } else if (hour >= 11 && hour < 13) {
        return "中午好";
      } else if (hour >= 13 && hour < 18) {
        return "下午好";
      } else {
        return "晚上好";
      }
    },
    isNotLogin() {
      return !getLocalToken("tal_token");
    },
    defaultPlaceholder() {
      return (
        this.prologueDesc ||
        "我可以协助您完成备课教学过程中的各项任务，请在此处告诉我您的问题～"
      );
    },
  },
  methods: {
    // 增加快捷键
    handleKeyDown(e) {
      // 按shift+enter时不触发搜索
      if (e.keyCode === 13 && e.shiftKey) {
        return;
      }

      if (e.keyCode === 13 && !e.ctrlKey) {
        e.preventDefault(); // 阻止默认的换行行为
        this.handleSend();
      }
    },
    handleInputClick() {
      console.log("handleInputClick");
      sensors.track("chatbot_dialog_box_click");
    },
    // 检查存储的消息
    checkLoginRequest() {
      console.log("检查存储的消息");
      if (this.checkedLoginInfo) return;
      this.checkedLoginInfo = true;
      const loginRequest = localStorage.getItem("newHomeRequest");
      if (loginRequest) {
        try {
          const requestData = JSON.parse(loginRequest);
          if (requestData) {
            console.log("存储的消息存在", requestData);
            this.inputText = requestData?.content;
            this.currentAppId = requestData?.appId;
            this.isDeepThink = requestData?.isDeepThink;
            this.category = requestData?.category || "aiassistant";
            this.jumpChat(
              "inputClick",
              requestData?.appId,
              requestData?.name,
              requestData?.isTemplate,
              this.category
            );
            // 清除已处理的请求状态
            localStorage.removeItem("newHomeRequest");
            this.checkedLoginInfo = false;
          }
        } catch (error) {
          console.error("登录请求获取失败:", error);
          localStorage.removeItem("loginMessageRequest");
        }
      }
    },
    jumpChat(from, appId, name, isTemplate, category) {
      console.log("jumpChat", appId, name, isTemplate, category);
      let params;
      if (appId && name && this.category !== "aiassistant") {
        params = {
          appId: appId || this.currentAppId,
          name: name,
        };
      } else {
        params = {
          appId: appId || this.currentAppId,
          content: this.inputText,
        };
      }

      if (isTemplate) {
        params.isTemplate = isTemplate;
      }

      if (
        ["miniprogram", "aiquestion", "image2image"].includes(this.category)
      ) {
        params.isTemplate = 1;
      }

      params.isDeepThink = this.isDeepThink ? 1 : 0;

      // params.from = from;
      params.category = category;
      this.$store.dispatch("app/setIsFrom", from);

      if (from === "inputClick") {
        addAiassistantList({}).then((res) => {
          if (res.code === 200) {
            console.log("inputClick", params);
            this.$router.push({
              name: "chat",
              query: params,
            });
          }
        });
      } else {
        if (this.isNotLogin) {
          this.$router.push({
            name: "chat",
            query: params,
          });
        } else {
          addMyAppList({ appId: appId }).then((res) => {
            if (res.code === 200) {
              this.$router.push({
                name: "chat",
                query: params,
              });
            }
          });
        }
      }
    },
    // 深度思考按钮点击事件 - 预留接口
    handleDeepThink() {
      sensors.track("chatbot_dialog_deep_click");
      // TODO: 调用深度思考接口
      this.isDeepThink = !this.isDeepThink;
      console.log("深度思考点击", this.inputText, this.isDeepThink);
    },

    // 发送按钮点击事件 - 预留接口
    handleSend() {
      console.log("handleSend", this.inputText);
      sensors.track("chatbot_dialog_confirm_click", {
        content: this.inputText,
      });
      if (!this.inputText) {
        const h = this.$createElement;
        this.$message({
          message: h("p", null, [h("span", null, "请输入问题")]),
          type: "warning",
          center: true,
        });
        return;
      }
      console.log("发送点击", this.inputText);
      // 存储请求信息，等待登录成功或跳转 chat 后处理
      localStorage.setItem(
        "newHomeRequest",
        JSON.stringify({
          appId: this.currentAppId,
          name: this.currentAppName,
          isTemplate: this.currentAppIsTemplate,
          category: this.category || "aiassistant",
          content: this.inputText,
          isDeepThink: this.isDeepThink,
          timestamp: Date.now(),
        })
      );
      // TODO: 调用发送接口
      if (this.isNotLogin) {
        this.handleJumpLoginClick();
      } else {
        this.jumpChat(
          "inputClick",
          this.currentAppId,
          this.currentAppName,
          this.currentAppIsTemplate,
          this.category
        );
      }
    },
    // 处理无登录态点击事件
    handleJumpLoginClick(event) {
      console.log(
        "newHomeRequest",
        JSON.parse(localStorage.getItem("newHomeRequest"))
      );
      return sObserver.fire("laoshibang-login");
    },

    // 功能按钮点击事件 - 预留接口
    handleFunctionClick(item) {
      console.log("功能按钮点击", item);
      this.category = item?.category;
      // TODO: 根据功能类型调用对应接口
      if (item.name === "更多应用") {
        sensors.track("chatbot_app_more_click");
        const abTestInfo = JSON.parse(localStorage.getItem("abTestInfo"));
        if (abTestInfo?.strategy === "B") {
          this.$router.push({ path: "/home/index" });
        } else if (abTestInfo?.strategy === "A") {
          this.$router.push({ path: "/apps/index" });
        }
      } else {
        sensors.track("chatbot_app_recom_click", {
          name: item?.name,
          app_id: item?.appId,
        });
        console.log("item?.appId", item?.appId);
        this.jumpChat(
          "appClick",
          item?.appId,
          item?.name,
          item?.template,
          item?.category
        );
      }
    },

    // 从接口获取功能按钮配置 - 预留接口
    async fetchFunctionItems() {
      // TODO: 调用接口获取功能按钮配置
      // const response = await this.$api.getFunctionItems();
      // this.functionItems = response.data;
      const res = await getRecommendAppList({});
      this.functionItems = res.data;
      this.functionItems.push({
        id: 5,
        name: "更多应用",
        logo: this.moreAppIcon,
        color: "",
      });

      console.log("functionItems", this.functionItems);
    },

    async getDeepThinkConfig() {
      getAiassistantInfo({ ty: "search" }).then((res) => {
        if (res.code === 200) {
          for (const item in res.data) {
            console.log("item", item, res.data[item]);
            this.isShowDeepThink = res.data[item]?.isDeepseek;
            this.currentAppId = item;
            this.prologueDesc = res.data[item]?.prologueDesc;
            this.category = res.data[item]?.category || "aiassistant";
          }
        }
      });
    },
  },

  async mounted() {
    await this.getDeepThinkConfig();
    // 页面加载时获取功能按钮配置
    this.fetchFunctionItems();
    this.checkLoginRequest();
    sensors.track("chatbot_show");
  },
};
</script>

<style scoped>
.home-container {
  height: 100%;
  background: #f8faff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

.main-content {
  width: 100%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.greeting-section {
  text-align: center;
  color: #323233;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.greeting-section .emoji {
  img {
    width: 82px;
    height: 82px;
  }
}

.greeting-section .greeting-text {
  font-size: 32px;
  font-weight: 600;
  margin: 0;
  /* text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); */
}

.input-section {
  width: 100%;
  max-width: 800px;
}

.input-container {
  background: white;
  border-radius: 16px;
  padding: 20px;
  border: 1px solid #e0e0e066;
  /* box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1); */
  /* backdrop-filter: blur(10px); */
}

.input-container .input-textarea {
  width: 100%;
  border: none;
  outline: none;
  resize: none;
  font-size: 16px;
  line-height: 1.5;
  color: #333;
  background: transparent;
  margin-bottom: 16px;
  box-sizing: border-box;
}

.input-container .input-textarea::placeholder {
  color: #999;
}

.input-container .action-buttons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}

.input-container .deep-think-btn {
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 40px !important;
  padding: 8px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0px;
  color: #323233;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  margin-right: auto;
}

.input-container .send-btn {
  /* background: #5a9cff; */
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
}

.input-container .send-btn:hover {
  /* background: #4085e6; */
  transform: scale(1.05);
}

.input-container .send-btn .send-icon {
  width: 20px;
  height: 20px;
}

.input-container .deep-think-btn.is-deep-think {
  background: #ffffff;
  border: 1px solid #0d70ed;
  color: #0d70ed;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .home-container {
    padding: 16px;
  }

  .main-content {
    gap: 32px;
  }

  .greeting-section .emoji {
    font-size: 48px;
    margin-bottom: 16px;
  }

  .greeting-section .greeting-text {
    font-size: 24px;
  }

  .button-row {
    gap: 16px;
  }

  .function-item .function-icon {
    width: 48px;
    height: 48px;
    font-size: 20px;
  }

  .function-item .function-text {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .greeting-section .greeting-text {
    font-size: 20px;
  }

  .input-container {
    padding: 16px;
  }

  .button-row {
    gap: 12px;
  }

  .function-item .function-icon {
    width: 40px;
    height: 40px;
    font-size: 18px;
  }
}
.app-search-buttons {
  .button-row {
    justify-content: center;
  }
}
.deep-think-icon {
  width: 12px;
  height: 12px;
  margin-right: 4px;
  display: block;
}
</style>
